import React, { useContext } from 'react';
var FormContext = React.createContext();
export default FormContext;
export var useFormContext = function useFormContext() {
  return useContext(FormContext);
};
export var withFormContext = function withFormContext(cb) {
  return React.createElement(FormContext.Consumer, null, cb);
};